module.exports = __webpack_public_path__ + "static/img/29.1853402.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ITO/29.png
// module id = diHh
// module chunks = 1